var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404Image(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1348,
    height: 384,
    viewBox: "0 0 1348 384",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1133_9163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 11C2 5.47716 6.47715 1 12 1H1336C1341.52 1 1346 5.47715 1346 11V371C1346 376.523 1341.52 381 1336 381H12C6.47711 381 2 376.523 2 371V11Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 41V340.999",
    stroke: "#DADEE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M157.086 41V340.999",
    stroke: "#DADEE6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M272.168 41V340.999",
    stroke: "#DADEE6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M387.254 41V340.999",
    stroke: "#DADEE6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M502.336 41V340.999",
    stroke: "#DADEE6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M617.418 41V340.999",
    stroke: "#DADEE6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M732.5 41V340.999",
    stroke: "#DADEE6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M847.586 41V340.999",
    stroke: "#DADEE6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M962.672 41V340.999",
    stroke: "#DADEE6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1077.75 41V340.999",
    stroke: "#DADEE6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1192.84 41V340.999",
    stroke: "#DADEE6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1305.84 41V340.999",
    stroke: "#DADEE6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42 341H1306",
    stroke: "#DADEE6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M42 298.015H1306",
    stroke: "#DADEE6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M42 255.029H1306",
    stroke: "#DADEE6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M42 212.045H1306",
    stroke: "#DADEE6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42 169.06H1306",
    stroke: "#DADEE6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M42 126.074H1306",
    stroke: "#DADEE6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M42 83.0901H1306",
    stroke: "#DADEE6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M42 41H1306",
    stroke: "#DADEE6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1305.5 341V329L43 52.5V341H1305.5Z",
    fill: "#FFE8E9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M45 53L1303 328",
    stroke: "#EF353F",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1133_9163",
    x: 0,
    y: 0,
    width: 1348,
    height: 384,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1133_9163"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1133_9163",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Image);
export default __webpack_public_path__ + "static/media/404-image.affc2cb8db234995aba5fe808521f95a.svg";
export { ForwardRef as ReactComponent };